import { Repeat, Gem, Clapperboard, Star, Building2, ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const MODELS = [
  { icon: Repeat, title: "Subscriptions", text: "Recurring access to the interactive AI companion platform.", path: "/business-model/subscriptions" },
  { icon: Gem, title: "Premium Interactive Experiences", text: "Enhanced real-time experiences for premium members.", path: "/business-model/premium-interactive-experiences" },
  { icon: Clapperboard, title: "Live AI Entertainment", text: "Scheduled live sessions and entertainment formats.", path: "/business-model/live-ai-entertainment" },
  { icon: Star, title: "Premium AI Characters", text: "Exclusive characters with distinct personalities and presentation.", path: "/business-model/premium-ai-characters" },
  { icon: Building2, title: "Future B2B Opportunities", text: "Licensing and partnership models over the longer term.", path: "/business-model/future-b2b" },
];

export default function BusinessModel() {
  return (
    <section id="business-model" data-testid="business-model-section" className="relative py-16 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <SectionTag>Business Model</SectionTag>
          <h2 className="font-display mt-5 max-w-xl text-3xl font-light tracking-tighter text-white sm:text-4xl lg:text-5xl">
            Potential <span className="text-cyan-300">Business Model</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#C5CBD5]">
            We are exploring potential revenue models for the future commercial platform.
            Commercial pricing has not been finalised.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {MODELS.map(({ icon: Icon, title, text, path }, i) => (
            <Reveal key={title} delay={0.07 * i} className={i === 4 ? "sm:col-span-2 lg:col-span-1" : ""}>
              <a
                href={path}
                data-testid={`model-card-${i}`}
                className="group flex h-full flex-col rounded-2xl border border-cyan-300/15 bg-white/[0.03] p-8 transition-colors duration-500 hover:border-cyan-300/40"
              >
                <Icon size={20} className="text-cyan-300/80 transition-transform duration-500 group-hover:-translate-y-1" />
                <h3 className="font-display mt-5 text-lg font-medium tracking-tight text-white">{title}</h3>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-[#C5CBD5]">{text}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-cyan-300/80 transition-colors duration-300 group-hover:text-cyan-100">
                  Learn more
                  <ArrowRight size={12} className="transition-transform duration-300 group-hover:translate-x-0.5" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 text-xs leading-relaxed text-white/55">
            These are potential future revenue models. AIROBOTCAMSTUDIO LTD does not currently
            generate revenue and has no customers.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
